import createClient from 'openapi-fetch';
import type { paths } from './inventory.openapi';
import { createOpenApiAdapter } from '../../shared/infra/fetch-open-api-adapter';

const inventoryFetchClient = createClient<paths>({
	baseUrl: process.env.REACT_APP_INVENTORY_ENDPOINT,
});

export const inventoryFetchClientAdapter = createOpenApiAdapter<paths>(inventoryFetchClient);
